import BaseApi from 'api/base';
import {
  CLINIC_ADMIN_PATIENT_ADHERENCE_URL_V2,
  DEFAULT_PAGINATION_LIMIT,
} from 'api/constants';
import { camelCaseKeys } from 'utils/normalizeData';

export type AdherenceParamsType = {
  locationId?: string;
  patientIds?: string[];
  sortProp?: string;
  sortOrder?: string;
};

export default {
  getPatientAdherenceList: async (
    params: AdherenceParamsType,
  ): Promise<IPaginationResponse> => {
    const { locationId, patientIds, sortOrder, sortProp } = params;
    const qs = new URLSearchParams();

    qs.set('limit', DEFAULT_PAGINATION_LIMIT);

    // if no locationId value provided, exclude this param and will return for all locations
    if (locationId) {
      qs.set('location_id', locationId);
    }

    // may provide both params for a sort, however this is handled by /patient-search
    if (sortProp && sortOrder) {
      qs.set('sortBy', sortProp);
      qs.set('sort', sortOrder);
    }

    const url = `${CLINIC_ADMIN_PATIENT_ADHERENCE_URL_V2()}?${qs.toString()}`;

    const { meta, data }: IPaginationResponse = await BaseApi.authRequest(
      url,
      {
        method: 'POST',
        body: JSON.stringify({
          patient_ids: patientIds,
        }),
      },
      true,
    );

    return {
      meta,
      data: camelCaseKeys(data),
    };
  },
};
